import React from "react";
import Icons from "Common/Icons";
import { Button } from "antd";
import "./Styles/BackButton.scss";
import { CONSTANTS } from "utils/constant";
import { useTranslation, Trans, withTranslation } from "react-i18next";
import { PRIMARY_LANG } from "Common/constant";
import { LANG_STYLD_EXT } from "Common/constant";
import { TS_STYLD_COMPS } from "Common/constant";
import { connect } from "react-redux";


const BackButtonEmptyBackground =(props)=>{
    const { t, i18n } = useTranslation();
  const tgtLang = props.includePrimeLang
    ? i18n.language + "_" + PRIMARY_LANG
    : i18n.language;
  const tgtLangST = props.includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;
    return(
        <Button className="back-btn-without-background" onClick={()=>props.navigateBackPage()} icon={<img src={Icons.back_arrow_small}/>}>
        {props?.label|| <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.BACK,{lng:tgtLangST})}</Trans>}
    </Button>
    )
}
const mapStateToProps = (state) => {
  return {
    includePrimeLang: state.loginReducer.includePrimeLang,
  };
};
const mapDispatchToProps = null;
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BackButtonEmptyBackground)
);
